import { render, staticRenderFns } from "./dividendreport.vue?vue&type=template&id=3d320973&scoped=true"
import script from "./dividendreport.vue?vue&type=script&lang=js"
export * from "./dividendreport.vue?vue&type=script&lang=js"
import style0 from "./dividendreport.vue?vue&type=style&index=0&id=3d320973&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d320973",
  null
  
)

export default component.exports